import { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import ConnectWithManagerButton from 'application/components/ConnectWithManagerButton';
import {
  STREAM_GROUPS_COLLECTION_PAGE_PATH,
  STREAM_SEARCH_PAGE_PATH_FOUND_ALIAS,
  STREAM_SUB_COLLECTIONS_PAGE_PATH,
  STREAMS_CATEGORY_ALL_PATH,
  STREAMS_CATEGORY_RECOMMENDED_PATH,
} from 'application/consts';
import { matchRoutes, useLocation } from 'application/providers/RouterProvider';
import { useAccountSelectors } from 'application/hooks';
import { useAppSelector } from '@shared/store';

import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import styles from './index.module.scss';

const PATHS_WITH_BUTTON_AND_TAGS = [
  { path: STREAM_GROUPS_COLLECTION_PAGE_PATH },
  { path: STREAM_SEARCH_PAGE_PATH_FOUND_ALIAS },
  { path: STREAM_SUB_COLLECTIONS_PAGE_PATH },
  { path: STREAMS_CATEGORY_ALL_PATH },
  { path: STREAMS_CATEGORY_RECOMMENDED_PATH },
];

const getDescription = (isOpenedFromStreamPage: boolean, isWaitPayment?: boolean) => {
  if (isWaitPayment) {
    return TEXTS.MODAL_STREAM_ADD_POINT_WAIT_PAYMENT_DESCRIPTION;
  }

  if (!isOpenedFromStreamPage) {
    return TEXTS.MODAL_STREAM_ADD_POINT_PROBLEM_DESCRIPTION_FALLBACK;
  }

  return TEXTS.MODAL_STREAM_ADD_POINT_PROBLEM_DESCRIPTION;
};

const DenyOperationModal: FC<ModalProps[ModalTypes.DENY_OPERATION]> = ({ close }) => {
  const location = useLocation();

  const isOpenedFromStreamPage = Boolean(matchRoutes(PATHS_WITH_BUTTON_AND_TAGS, location));

  const selectors = useAccountSelectors();

  const companyCountry = useAppSelector(selectors.selectCompanyCountry);
  const isBillingEnabled = useAppSelector(selectors.selectCompanyIsBillingEnabled);

  return (
    <ModalScreen
      title={
        isOpenedFromStreamPage
          ? TEXTS.MODAL_STREAM_ADD_POINT_PROBLEM_TITLE
          : TEXTS.MODAL_STREAM_ADD_POINT_PROBLEM_TITLE_FALLBACK
      }
      titlePlacement="left"
      onClose={close}
      actionButtons={[<ConnectWithManagerButton country={companyCountry} />]}>
      <div className={styles.description}>{getDescription(isOpenedFromStreamPage, isBillingEnabled)}</div>
    </ModalScreen>
  );
};

export default memo(DenyOperationModal);
